<template>
    <div class="d-flex align-self-center">
        <fieldset class="rating my-0 mx-auto">
            <input type="radio" id="star5" name="rating" value="5" v-on:change="emit('stars-click')" v-model="picked"/><label class = "full glow" for="star5" title="Awesome - 5 stars"></label>
            <!-- <input type="radio" id="star4half" name="rating" value="4 and a half" /><label class="half" for="star4half" title="Pretty good - 4.5 stars"></label> -->
            <input type="radio" id="star4" name="rating" value="4" v-on:change="emit('stars-click')" v-model="picked"/><label class = "full" for="star4" title="Pretty good - 4 stars"></label>
            <!-- <input type="radio" id="star3half" name="rating" value="3 and a half" /><label class="half" for="star3half" title="Meh - 3.5 stars"></label> -->
            <input type="radio" id="star3" name="rating" value="3" v-on:change="emit('stars-click')" v-model="picked"/><label class = "full" for="star3" title="Meh - 3 stars"></label>
            <!-- <input type="radio" id="star2half" name="rating" value="2 and a half" /><label class="half" for="star2half" title="Kinda bad - 2.5 stars"></label> -->
            <input type="radio" id="star2" name="rating" value="2" v-on:change="emit('stars-click')" v-model="picked"/><label class = "full" for="star2" title="Kinda bad - 2 stars"></label>
            <!-- <input type="radio" id="star1half" name="rating" value="1 and a half" /><label class="half" for="star1half" title="Meh - 1.5 stars"></label> -->
            <input type="radio" id="star1" name="rating" value="1" v-on:change="emit('stars-click')" v-model="picked"/><label class = "full" for="star1" title="Sucks big time - 1 star"></label>
            <!-- <input type="radio" id="starhalf" name="rating" value="half" /><label class="half" for="starhalf" title="Sucks big time - 0.5 stars"></label> -->
        </fieldset>
    </div>
</template>

<script>
    export default {
    name: 'Stars',
            data() 
            {
              return {            
                picked: 0,
              }
            },
            props: ['app'],
            methods: {
                emit: function(eventname) {
                    this.$emit(eventname, this.picked)
                }
            }
        }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   @import url(//netdna.bootstrapcdn.com/font-awesome/3.2.1/css/font-awesome.css);

fieldset, label {margin: 0; padding: 0; }
body{ margin: 20px; }
h1 { font-size: 1.5em; margin: 10px; }

/****** Style Star Rating Widget *****/

.rating { 
  border: none;
  float: left;
}

.rating > input { display: none; } 
.rating > label:before { 
  margin: 5px;
  /* font-size: 1.25em; */
  font-size: 2.5em;
  font-family: FontAwesome;
  display: inline-block;
  content: "\f005";
}

.rating > .half:before { 
  content: "\f089";
  position: absolute;
}

.rating > label { 
  /* color: #ddd;  */
  color: #f1f1f1; 
 float: right; 
}

/***** CSS Magic to Highlight Stars on Hover *****/

.rating > input:checked ~ label, /* show gold star when clicked */
.rating:not(:checked) > label:hover, /* hover current star */
.rating:not(:checked) > label:hover ~ label { color: #FFD700;  } /* hover previous stars in list */

.rating > input:checked + label:hover, /* hover current star when changing rating */
.rating > input:checked ~ label:hover,
.rating > label:hover ~ input:checked ~ label, /* lighten current selection */
.rating > input:checked ~ label:hover ~ label { color: #FFD700;  }

.glow {
  -webkit-animation: glow 1s ease-in-out infinite alternate;
  -moz-animation: glow 1s ease-in-out infinite alternate;
  animation: glow 1s ease-in-out infinite alternate;
}

@-webkit-keyframes glow {
  from {
    text-shadow: 0 0 1px #fff, 0 0 2px #fff, 0 0 3px #FFF, 0 0 4px #FFF, 0 0 5px #FFF, 0 0 6px #FFF, 0 0 7px #FFF;
  }
  
  to {
    text-shadow: 0 0 4px #fff, 0 0 5px #FFF192, 0 0 6px #FFF192, 0 0 7px #FFF192, 0 0 8px #FFF192, 0 0 9px #FFF192, 0 0 10px #FFF192;
  }
}

</style>
